unable to read source [project]/packages/src/utils/legacyThemeAdapter.ts